import * as echarts from 'echarts';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import { formatTime, sortArrDesc, formatEnNumber } from '@/pages/intelligence/pages/MarketProfile/_util';;
import ChartBubble from "@/pages/intelligence/components/ChartBubble";

export const drawLineChart = (
  containId:string,
  data:any,
  xAxis:any,
  legendSelected:any,
  color:any,
  nameFormatter?: (name: string) => string,
  xAxisLabelFormatter?: (name: string) => string,
) => {
  let chartDom = document.getElementById(containId);
  if (chartDom) {
    let myChart = echarts.getInstanceByDom(chartDom);
    if (myChart == null) {
      myChart = echarts.init(chartDom);
    }
    const lineFormatterTooltip=(params:any)=>{
      return ChartBubble({
        data:params?.sort(sortArrDesc('value')),
        headerLeftTitle:'',
        headerRightTitle:'Revenue',
        imageType: 'mobile',
        chartType:'line',
        dateType:'month',
        ifNoBarImg:true,
        useSerieNameFormatter: !!nameFormatter,
        serieNameFormatter: nameFormatter,
      })}
    let option = {
      title: {
        show: false,
      },
      color: color,
      // tooltip: {
      //   trigger: 'axis',
      //   // valueFormatter: function (params) {
      //   //   return formatNum(params);
      //   // },
      //   order: 'valueDesc',
      // },
      tooltip: {
        padding: 0,
        borderWidth: 0,
        trigger: 'axis',
        formatter: lineFormatterTooltip,
        backgroundColor: 'rgba(0, 0, 0, 0)',
      },
      legend: {
        show: true,
        bottom: 0,
        // selected: legendSelected,
        lineStyle: {
          opacity: 0,
        },
        icon: 'circle',
        type: 'scroll',
        itemWidth: 8,
        formatter: nameFormatter,
      },
      grid: {
        top: '2%',
        left: '0%',
        right: '0%',
        bottom: '8%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: true,
          data: xAxis,
          axisLine: {
            color: '#BBBBBB',
          },
          axisTick: { alignWithLabel: true },
          axisLabel: {
            formatter: function (value) {
              return xAxisLabelFormatter?.(value) ?? value;
            },
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: '#BBBBBB',
            formatter: function (value, index) {
              return formatNum(value);
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: '#BBBBBB',
              type: 'dashed',
            },
          },
        },
      ],
      series: data,
    };
    option && myChart.setOption(option, true);
    myChart.resize();
  }
};

export const drawLineChart2 = (
  containId:string,
  data:any,
  xAxis:any,
  rightTitle:string,
  nameFormatter?: (name: string) => string,
  xAxisLabelFormatter?: (name: string) => string,
) => {
  let chartDom = document.getElementById(containId);
  if (chartDom) {
    let myChart = echarts.getInstanceByDom(chartDom);
    if (myChart == null) {
      myChart = echarts.init(chartDom);
    }
    const lineFormatterTooltip=(params:any)=>{
      return ChartBubble({
        data:params?.sort(sortArrDesc('value')),
        headerLeftTitle:'',
        headerRightTitle:rightTitle,
        imageType: 'mobile',
        chartType:'line',
        dateType:'month',
        ifNoBarImg:true,
        useSerieNameFormatter: !!nameFormatter,
        serieNameFormatter: nameFormatter,
      })}
    // let myChart = echarts.init(chartDom);
    let option = {
      title: {
        show: false,
      },
      tooltip: {
        trigger: 'axis',
        padding: 0,
        borderWidth: 0,
        formatter: lineFormatterTooltip,
        backgroundColor: 'rgba(0, 0, 0, 0)',
      },
      legend: {
        show: true,
        bottom: 0,
        lineStyle: {
          opacity: 0,
        },
        icon: 'circle',
        type: 'scroll',
        itemWidth: 8,
        formatter: nameFormatter,
      },
      grid: {
        top: '20px',
        left: '0%',
        right: '2%',
        bottom: '40px',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: true,
          data: xAxis,
          axisTick: { alignWithLabel: true },
          axisLine: {
            color: 'rgba(0,0,0,0.45)',
          },
          axisLabel: {
            formatter: function (value) {
              return xAxisLabelFormatter?.(value) ?? value;
            },
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: 'rgba(0,0,0,0.45)',
            formatter: function (value, index) {
              return formatNum(value);
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: '#E9E9E9',
            },
          },
        },
      ],
      series: data,
    };
    option && myChart.setOption(option, true);
    myChart.resize();
  }
};

export const mpTreeMapCharts = (containId, data, nodeClick = false) => {
  let chartDom = document.getElementById(containId);
  if (chartDom) {
    let myChart = echarts.getInstanceByDom(chartDom);
    if (myChart == null) {
      myChart = echarts.init(chartDom);
    }
    let option = {
      title: {
        show: false,
      },
      tooltip: {
        formatter: function (params) {
          let precent = params.data.totalValue && params.data.totalValue != 0 ? formatPercentNum(params.value / params.data.totalValue) : 0;
          let html =
            '<div>' +
            '<div style="width:100%;height:16px;float:left;color:rgba(0,0,0,0.45);font-size:12px;">' +
            formatTime(params.data.time) +
            '</div>' +
            '<div style="width:auto;height:16px;float:left;color:rgba(0,0,0,0.65);font-size:12px;margin-top:8px;">' +
            '<div style="width:auto;height:16px;float:left;">' +
            params.name +
            '</div>' +
            '<div style="width:auto;height:16px;float:left;margin-left:10px;">' +
            formatNum(params.value, true) +
            '</div>' +
            '<div style="width:auto;height:16px;float:left;margin-left:10px;">' +
            precent +
            '</div>' +
            '</div>' +
            '</div>';
          return html;
        },
        backgroundColor: 'rgba(0, 0, 0, 0)',
      },
      legend: {
        show: false,
      },
      series: [
        {
          name: 'option',
          type: 'treemap',
          visibleMin: 300,
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          drillDownIcon: '',
          roam: false,
          nodeClick: nodeClick,
          breadcrumb: { show: false },
          data: data,
          leafDepth: 1,
          levels: [
            {
              itemStyle: {
                borderColor: 'rgba(255,255,255,0.4)',
                gapWidth: 2,
              },
            },
            {
              colorSaturation: [0.3, 0.6],
              itemStyle: {
                borderColor: 'rgba(255,255,255,0.4)',
                gapWidth: 2,
              },
            },
          ],
        },
      ],
    };
    option && myChart.setOption(option, true);
    myChart.resize();
    // myChart.on('click', function (params) {
    //     // //@ts-ignore
    //     // if (params?.data?.children?.length > 0) {

    //     // } else {
    //     //     // let name = aaa[0] || params.name;
    //     //     // fun && fun(name);
    //     // }
    // });
  }
};

//更新地图数据
export const refreshLineData = (containId, data, xAxis) => {
  let chartDom = document.getElementById(containId);
  if (chartDom) {
    let myChart = echarts.getInstanceByDom(chartDom);
    let option = myChart.getOption();
    option.xAxis[0].data = xAxis;
    option.series = [];
    option.series = data;
    myChart.setOption(option);
    myChart.resize();
  }
};
